import axios from "axios";

export const termsData = () => {
  return axios
    .get("/terms")
    .then((response) => {
      // console.log(response.data);
      return response;
    });
};